import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';

const PAGE_SIZE = 10;

const WalletHistory = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [partnerCode, setPartnerCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // Get Monday to Sunday of this week by default
  const getDefaultDates = () => {
    const today = dayjs();
    const startOfWeek = today.startOf('week').add(1, 'day'); // Monday
    const endOfWeek = today.endOf('week').add(1, 'day');     // Sunday
    return {
      from: startOfWeek.format('YYYY-MM-DD'),
      to: endOfWeek.format('YYYY-MM-DD')
    };
  };

  // Set initial default dates on mount
  useEffect(() => {
    const { from, to } = getDefaultDates();
    setFromDate(from);
    setToDate(to);
  }, []);
    const token = localStorage.getItem("token");

  const fetchData = async () => {
      const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable

    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}Renew/GetNewWallet`, {
        pageIndex,
        pageSize: PAGE_SIZE,
        fromDate,
        toDate,
        partnerCode: partnerCode || "0",
        countryCode: '',
      }, {
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      const resData = response.data;
      if (resData.isSuccess) {
        setData(resData.getwallet || []);
        setTotalCount(resData.totalCount);
      }
    } catch (error) {
      console.error('API error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fromDate && toDate) {
      fetchData();
    }
  }, [pageIndex]);

  const handleSearch = () => {
    setPageIndex(1);
    fetchData();
  };

  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-2xl font-semibold mb-4">Wallet History</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <input
          type="text"
          placeholder="Search Partner Code"
          className="border border-gray-300 rounded px-4 py-2"
          value={partnerCode}
          onChange={(e) => setPartnerCode(e.target.value)}
        />

        <input
          type="date"
          className="border border-gray-300 rounded px-4 py-2"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <input
          type="date"
          className="border border-gray-300 rounded px-4 py-2"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Search
        </button>
      </div>

      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded shadow-sm">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="py-2 px-4 text-left">Date</th>
                <th className="py-2 px-4 text-left">Amount</th>
                <th className="py-2 px-4 text-left">Type</th>
                <th className="py-2 px-4 text-left">Partner Code</th>
                <th className="py-2 px-4 text-left">Balance</th>
                <th className="py-2 px-4 text-left">Plan</th>
                <th className="py-2 px-4 text-left">Order ID</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? data.map((item, index) => (
                <tr key={index} className="border-t hover:bg-gray-50">
                  <td className="py-2 px-4">{item.date}</td>
                  <td className="py-2 px-4">${item.amount}</td>
                  <td className="py-2 px-4">{item.type}</td>
                  <td className="py-2 px-4">{item.description}</td>
                  <td className="py-2 px-4">{item.balance}</td>
                  <td className="py-2 px-4">{item.planename}</td>
                  <td className="py-2 px-4">{item.orderID}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-gray-500">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => setPageIndex((prev) => Math.max(prev - 1, 1))}
          disabled={pageIndex === 1}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Previous
        </button>

        <span className="text-gray-700">Page {pageIndex} of {totalPages}</span>

        <button
          onClick={() => setPageIndex((prev) => Math.min(prev + 1, totalPages))}
          disabled={pageIndex === totalPages}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default WalletHistory;
